import RecordMeta from './record-meta';

export default RecordMeta;
